import { useState } from 'react'

export type CardBrand =
  | 'american-express'
  | 'diners-club'
  | 'discover'
  | 'elo'
  | 'hiper'
  | 'hipercard'
  | 'jcb'
  | 'maestro'
  | 'mastercard'
  | 'mir'
  | 'unionpay'
  | 'visa'
  | 'unknown'
  | null

export interface BasisTheoryValidationError {
  message: string
  type: string
}

export const useCardBrand = () => {
  const [cardBrand, setCardBrand] = useState<CardBrand>(null)
  return { cardBrand, setCardBrand }
}
